var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenInBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open-in-browser"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09375 7.35C5.09375 5.82776 6.32777 4.59375 7.85 4.59375H42.15C43.6722 4.59375 44.9062 5.82777 44.9062 7.35V41.65C44.9062 43.1722 43.6722 44.4062 42.15 44.4062H16.8333C15.9876 44.4062 15.3021 43.7207 15.3021 42.875C15.3021 42.0293 15.9876 41.3438 16.8333 41.3438H41.8438V7.65625H8.15625V32.6667C8.15625 33.5124 7.47069 34.1979 6.625 34.1979C5.77931 34.1979 5.09375 33.5124 5.09375 32.6667V7.35Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3854 12.25C19.3854 11.4043 20.071 10.7188 20.9167 10.7188H37.25C38.0957 10.7188 38.7812 11.4043 38.7812 12.25C38.7812 13.0957 38.0957 13.7812 37.25 13.7812H20.9167C20.071 13.7812 19.3854 13.0957 19.3854 12.25Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2188 12.25C11.2188 11.4043 11.9043 10.7188 12.75 10.7188H14.7917C15.6374 10.7188 16.3229 11.4043 16.3229 12.25C16.3229 13.0957 15.6374 13.7812 14.7917 13.7812H12.75C11.9043 13.7812 11.2188 13.0957 11.2188 12.25Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8333 26.0312C15.9876 26.0312 15.3021 25.3457 15.3021 24.5C15.3021 23.6543 15.9876 22.9688 16.8333 22.9688H25C25.8457 22.9688 26.5312 23.6543 26.5312 24.5V32.6667C26.5312 33.5124 25.8457 34.1979 25 34.1979C24.1543 34.1979 23.4688 33.5124 23.4688 32.6667V28.1968L8.72859 42.9369C8.1306 43.5349 7.16107 43.5349 6.56308 42.9369C5.96509 42.3389 5.96509 41.3694 6.56308 40.7714L21.3032 26.0312H16.8333Z",
    fill: "#656579"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInBrowser);
export default __webpack_public_path__ + "static/media/open-in-browser.d5c5f69c39d5113e946f943306449d39.svg";
export { ForwardRef as ReactComponent };